import { Text } from "@/components/atoms/Text";
import {
  FunctionalCard,
  FunctionalCardContent,
  FunctionalCardDescription,
  FunctionalCardHeader,
  FunctionalCardTitle,
} from "@/components/molecules/cards/FunctionalCard";
import {
  Popover,
  PopoverClose,
  PopoverContent,
  PopoverTrigger,
} from "@/components/molecules/Popover";
import {
  PriceSummary,
  PriceSummaryRow,
} from "@/components/molecules/PriceSummary";
import XIcon from "@/icons/__generated__/X/X20";
import { FormattedMessage, FormattedNumber } from "react-intl";
import { AddOnFee } from "./add-on-counter-types";

type AddOnFeesPopoverProps = {
  fees: AddOnFee[];
  addOnName: string;
  currency: string;
};

export const AddOnFeesPopover = ({
  fees,
  addOnName,
  currency,
}: AddOnFeesPopoverProps) => {
  return (
    <Popover isResponsive={true}>
      <PopoverTrigger className="tw-flex tw-items-center">
        <Text typeface="body-1" className="tw-text-gray-600 tw-underline">
          <FormattedMessage defaultMessage="fees" />
        </Text>
      </PopoverTrigger>
      <PopoverContent align="start">
        <FunctionalCard className="tw-w-full sm:tw-w-[390px]">
          <FunctionalCardHeader
            closeButton={
              <PopoverClose aria-label="close">
                <XIcon />
              </PopoverClose>
            }
            className="tw-border-b tw-border-gray-200"
          >
            <FunctionalCardTitle>
              <FormattedMessage defaultMessage="Fees" />
            </FunctionalCardTitle>
            <FunctionalCardDescription>{addOnName}</FunctionalCardDescription>
          </FunctionalCardHeader>
          <FunctionalCardContent className="tw-text-gray-900">
            <PriceSummary textSize="large">
              {(fees || []).map((fee) => (
                <PriceSummaryRow
                  key={fee.label}
                  name={fee.label}
                  value={
                    <FormattedNumber
                      value={fee.amount}
                      style={fee.costBasis === "%" ? "percent" : "currency"}
                      currency={currency}
                      maximumFractionDigits={2}
                      minimumFractionDigits={
                        fee.costBasis === "%" || fee.amount % 1 === 0 ? 0 : 2
                      }
                    />
                  }
                />
              ))}
              <Text className="tw-caption-2 tw-text-gray-600 tw-max-w-[240px]">
                <FormattedMessage defaultMessage="Peerspace's processing fee and applicable taxes will be calculated in checkout." />
              </Text>
            </PriceSummary>
          </FunctionalCardContent>
        </FunctionalCard>
      </PopoverContent>
    </Popover>
  );
};
